import { GRADES } from '../config/constants';
import type { IScoringEvaluation } from '../types';

export const createGrade = ({ score, lowLimit, midLimit }: IScoringEvaluation): string => {
  if (score > 0 && score <= lowLimit) {
    return GRADES.LOW;
  }
  if (score > lowLimit && score <= midLimit) {
    return GRADES.MID;
  }
  return GRADES.HIGH;
};

export const createDescription = ({ score, lowLimit, midLimit }: IScoringEvaluation): string => {
  if (score) {
    return `У вас ${createGrade({ score, lowLimit, midLimit })} кредитный рейтинг`;
  }

  return 'Рейтинг не найден';
};
